import React from 'react';
import { Button } from '@chakra-ui/react';

/**
 * Calculator key — rectangular, keyboard-accessible, variants for digit / op / utility.
 */
const CalcButton = ({
  label,
  variant = 'digit',
  gridColumn,
  gridRow,
  onPress,
  ariaLabel,
  ...rest
}) => {
  const variants = {
    digit: {
      bg: 'gray.50',
      color: 'gray.800',
      borderWidth: '1px',
      borderColor: 'gray.200',
      _hover: { bg: 'gray.100', borderColor: 'gray.300' },
      _active: { bg: 'gray.200', transform: 'scale(0.98)' },
      _focusVisible: { boxShadow: '0 0 0 3px rgba(45, 212, 191, 0.45)' },
    },
    action: {
      bg: 'gray.100',
      color: 'gray.700',
      borderWidth: '1px',
      borderColor: 'gray.200',
      fontWeight: '600',
      _hover: { bg: 'gray.200', borderColor: 'gray.300' },
      _active: { bg: 'gray.300', transform: 'scale(0.98)' },
      _focusVisible: { boxShadow: '0 0 0 3px rgba(45, 212, 191, 0.45)' },
    },
    operator: {
      bg: 'teal.500',
      color: 'white',
      fontWeight: '600',
      borderWidth: '1px',
      borderColor: 'teal.600',
      _hover: { bg: 'teal.600', borderColor: 'teal.700' },
      _active: { bg: 'teal.700', transform: 'scale(0.98)' },
      _focusVisible: { boxShadow: '0 0 0 3px rgba(20, 184, 166, 0.5)' },
    },
    equals: {
      bg: 'teal.600',
      color: 'white',
      fontWeight: '700',
      borderWidth: '1px',
      borderColor: 'teal.700',
      _hover: { bg: 'teal.700', borderColor: 'teal.800' },
      _active: { bg: 'teal.800', transform: 'scale(0.98)' },
      _focusVisible: { boxShadow: '0 0 0 3px rgba(13, 148, 136, 0.55)' },
    },
  };

  const sx = variants[variant] ?? variants.digit;

  return (
    <Button
      type="button"
      variant="unstyled"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minH={{ base: '48px', sm: '52px' }}
      h="100%"
      w="100%"
      borderRadius="lg"
      fontSize={{ base: 'lg', sm: 'xl' }}
      fontVariantNumeric="tabular-nums"
      transition="background 0.12s ease, border-color 0.12s ease, transform 0.08s ease"
      userSelect="none"
      aria-label={ariaLabel ?? (typeof label === 'string' ? label : undefined)}
      gridColumn={gridColumn}
      gridRow={gridRow}
      onClick={onPress}
      {...sx}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default CalcButton;
